package com.mrpowergamerbr.powercmsjs

fun main() {
    val cms = PowerCMSJS()
    cms.start()
}